import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import { usePartner } from '../../contexts/PartnerContext';

const PartnerContextHeader = () => {
  const { partners, selectedPartnerId, selectedPartner, switchPartner, loading } = usePartner();
  const [isActionsOpen, setIsActionsOpen] = useState(false);

  const getTierDescription = (tier) => {
    if (!tier) return 'Partner';
    const t = tier?.toLowerCase();
    if (t === 'platinum') return 'Platinum Partner';
    if (t === 'gold') return 'Gold Partner';
    if (t === 'silver') return 'Silver Partner';
    if (t === 'bronze') return 'Bronze Partner';
    return `${tier} Partner`;
  };

  const getTierBadgeClass = (tier) => {
    const t = tier?.toLowerCase();
    if (t === 'platinum') return 'bg-primary/10 text-primary';
    if (t === 'gold') return 'bg-warning/10 text-warning';
    if (t === 'silver') return 'bg-muted text-muted-foreground';
    return 'bg-accent/10 text-accent';
  };

  const tierDescription = getTierDescription(selectedPartner?.tier);

  const quickActions = [
    { icon: 'Mail', label: 'Send Email', action: () => console.log('Send email') },
    { icon: 'Phone', label: 'Schedule Call', action: () => console.log('Schedule call') },
    { icon: 'FileText', label: 'View Documents', action: () => console.log('View documents') },
    { icon: 'BarChart3', label: 'View Analytics', action: () => console.log('View analytics') }
  ];

  return (
    <div className="sticky top-[128px] z-100 bg-card border-b border-border shadow-elevation-sm mt-[128px]">
      <div className="px-16 py-12">
        <div className="flex items-center justify-between gap-16">
          <div className="flex items-center gap-16 flex-1 min-w-0">
            <div className="flex items-center gap-12 min-w-0">
              <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon name="Building2" size={20} className="text-primary" />
              </div>

              {/* Desktop: real partner dropdown */}
              <div className="min-w-0 flex-1 hidden sm:block">
                {loading ? (
                  <div className="w-48 h-8 bg-slate-100 rounded animate-pulse" />
                ) : (
                  <select
                    value={selectedPartnerId || ''}
                    onChange={(e) => switchPartner(e?.target?.value)}
                    className="min-w-[200px] max-w-[300px] px-12 py-8 text-sm border border-border rounded-lg bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary/40"
                  >
                    {partners?.length === 0 && (
                      <option value="">No partners yet</option>
                    )}
                    {partners?.map(p => (
                      <option key={p?.id} value={p?.id}>
                        {p?.brand_name || p?.legal_name}
                      </option>
                    ))}
                  </select>
                )}
              </div>

              {/* Mobile: show name only */}
              <div className="sm:hidden min-w-0">
                <div className="font-medium text-foreground truncate">
                  {selectedPartner?.brand_name || selectedPartner?.legal_name || 'Select Partner'}
                </div>
                <div className="text-xs text-muted-foreground caption">
                  {tierDescription}
                </div>
              </div>
            </div>

            {selectedPartner && (
              <div className="hidden md:flex items-center gap-8">
                <span className={`inline-flex items-center gap-4 px-8 py-4 rounded-md text-xs font-medium caption ${getTierBadgeClass(selectedPartner?.tier)}`}>
                  <Icon name="Award" size={14} />
                  {tierDescription}
                </span>
                {selectedPartner?.country && (
                  <span className="inline-flex items-center gap-4 px-8 py-4 rounded-md text-xs text-muted-foreground bg-muted">
                    <Icon name="Globe" size={12} />
                    {selectedPartner?.country}
                  </span>
                )}
              </div>
            )}
          </div>

          <div className="flex items-center gap-8">
            <div className="hidden lg:flex items-center gap-4">
              {quickActions?.map((action, index) => (
                <Button
                  key={index}
                  variant="ghost"
                  size="sm"
                  iconName={action?.icon}
                  iconSize={16}
                  onClick={action?.action}
                >
                  {action?.label}
                </Button>
              ))}
            </div>

            <div className="lg:hidden relative">
              <Button
                variant="outline"
                size="sm"
                iconName="MoreVertical"
                iconSize={18}
                onClick={() => setIsActionsOpen(!isActionsOpen)}
              />

              {isActionsOpen && (
                <>
                  <div
                    className="fixed inset-0 z-1050"
                    onClick={() => setIsActionsOpen(false)}
                  />
                  <div className="absolute right-0 top-full mt-4 z-1100 bg-popover rounded-lg shadow-elevation-lg border border-border min-w-[200px] py-8">
                    {quickActions?.map((action, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          action?.action();
                          setIsActionsOpen(false);
                        }}
                        className="w-full flex items-center gap-12 px-16 py-12 text-sm text-popover-foreground hover:bg-muted transition-smooth"
                      >
                        <Icon name={action?.icon} size={18} />
                        {action?.label}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerContextHeader;